import { isNil } from 'mojito/utils';

/**
 * Utility functions associated with the milestone markets.
 *
 * @class GridLayoutUtils
 * @memberof Mojito.Presentation.Components.GridLayout
 */
export default class GridLayoutUtils {
    /**
     * It will apply column, row and position grid layout properties to the provided style object.
     *
     * @param {object} style - Style object.
     * @param {number} startColumn - Start column index.
     * @param {number} endColumn - End column index.
     * @param {number} startRow - Start column index.
     * @param {number} endRow - End column index.
     * @param {boolean} [useAbsolutePosition = false] - Either to use position absolute.
     *
     * @returns {object} Style object enriched with grid layout properties.
     *
     * @function Mojito.Presentation.Components.GridLayout.GridLayoutUtils.enrichGridLayout
     */
    static enrichGridLayout(
        style,
        startColumn,
        endColumn,
        startRow,
        endRow,
        useAbsolutePosition = false
    ) {
        const layoutProps = [startColumn, endColumn, startRow, endRow, useAbsolutePosition];
        const propsList = Object.values(layoutProps).filter(prop => !isNil(prop) && prop !== false);
        if (propsList.length === 0) {
            return style;
        }
        const result = { ...style };
        if (startColumn) {
            result.gridColumnStart = startColumn;
        }
        if (endColumn) {
            result.gridColumnEnd = endColumn + 1;
        }
        if (startRow) {
            result.gridRowStart = startRow;
        }
        if (endRow) {
            result.gridRowEnd = endRow + 1;
        }
        if (useAbsolutePosition) {
            result.position = 'absolute';
        }
        return result;
    }
}
